const getConfigValue = function(key) {
  let config = window.sessionStorage.getItem("config");

  if (!!config) {
    let configData = JSON.parse(config);

    return configData[key];
  }

  return null;
};

export { getConfigValue };
